import { authContract } from "@clipboard-health/contract-backend-main";
import { useMutation, type UseMutationResult } from "@tanstack/react-query";
import type { z } from "zod";

import { post } from "@src/appV2/api/parsedApi";
import { environmentConfig } from "@src/appV2/environment";
import { APP_V3_APP_EVENTS } from "@src/appV2/lib/analytics";

const resetUserPasswordContract = authContract.resetUserPassword;
const resetUserPasswordApiPath = resetUserPasswordContract.path.replace(/^\/api/, "");

export type ResetUserPasswordParams = z.input<typeof resetUserPasswordContract.body>;
export type ResetUserPasswordResult = z.output<(typeof resetUserPasswordContract.responses)[200]>;

export function useResetUserPassword(): UseMutationResult<
  ResetUserPasswordResult,
  unknown,
  ResetUserPasswordParams
> {
  return useMutation({
    mutationKey: ["reset-user-password"],
    mutationFn: async (params) => {
      const response = await post({
        url: `${environmentConfig.REACT_APP_BASE_API_URL}${resetUserPasswordApiPath}`,
        data: params,
        bodySchema: resetUserPasswordContract.body,
        responseSchema: resetUserPasswordContract.responses[200],
      });
      return response.data;
    },
    retry: false,
    meta: { logErrorMessage: APP_V3_APP_EVENTS.RESET_USER_PASSWORD_FAILURE },
  });
}
